module.exports = __webpack_public_path__ + "static/img/ALL.ca6a0754.jpg";